export class AddRiskCalculationCommentCommand {
    public text: string;

    public constructor(init: Partial<AddRiskCalculationCommentCommand>) {
        Object.assign(this, init);
    }
}
